import React from 'react'
import { useSelector } from 'react-redux'
import { GlgButton } from 'Shared/components'
import { selectSelectedLeaguesForCloning } from '../../reducers/selected_leagues_for_cloning'

import useSessionSaver from '../../hooks/useSessionSaver'
import useCloningStepsActions from '../../hooks/useCloningStepsActions'
import { selectCloningModal } from '../../reducers/cloning_steps'
import { CloningStepsModals } from '../../constants'
import MissingRenamesModal from './modals/MissingRenamesModal'
import CancelSessionModal from './modals/CancelSessionModal'

const ModalsMapping = {
  [CloningStepsModals.MISSING_LEAGUES_RENAMES]: <MissingRenamesModal/>,
  [CloningStepsModals.CANCEL_SESSION]: <CancelSessionModal/>,
}

const Footer = () => {
  const selectedLeaguesForCloning = useSelector(selectSelectedLeaguesForCloning)
  const cloningModal = useSelector(selectCloningModal)
  const { saveSessionToServer } = useSessionSaver()
  const { goToNextCloningStep, goToPrevCloningStep, isLastCloningStep } = useCloningStepsActions()

  return <div className={'cls-footer'}>
    <GlgButton
      text={window.I18n.t('buttons.back')}
      className={'cls-footer-button-dark'}
      onClick={() => goToPrevCloningStep()}
    />
    <GlgButton
      text={window.I18n.t('buttons.save_as_draft')}
      className={'cls-footer-button-dark'}
      onClick={() => saveSessionToServer()}
    />
    <GlgButton
      text={isLastCloningStep ? window.I18n.t('buttons.save') : window.I18n.t('buttons.continue') }
      className={'cls-footer-button'}
      disabled={selectedLeaguesForCloning.length <= 0}
      onClick={() => goToNextCloningStep()}
    />
    {cloningModal && ModalsMapping[cloningModal]}
  </div>
}

export default Footer
